export default "__VITE_ASSET__BQqbcwbX__"